import { BoardVisibility } from '@/api/common';
import { useSendCommand } from '@/_core/cqrs/use';
import { Action } from '@/_core/fluxstore/types';
import { SetBoardVisibilityParams } from '../../../api/commands';
import { StorymapState } from '../../types';
import { useStorymapStore } from '../../useModule';

const { registerReducer, registerMiddleware } = useStorymapStore();

export class SetWorkspaceMembersCanComment extends Action<StorymapState> {
    public static ACTION_TYPE = 'SetWorkspaceMembersCanComment';

    public constructor(public canComment: boolean) {
        super(SetWorkspaceMembersCanComment.ACTION_TYPE);
    }
}

const middleware = async (state: StorymapState, action: SetWorkspaceMembersCanComment): Promise<boolean> => {
    const visibility = state.isWorkspaceVisible ? BoardVisibility.WorkspaceVisible : BoardVisibility.Private;
    return await useSendCommand(action, {
        createCommand: () => new SetBoardVisibilityParams(state.id, visibility, action.canComment),
    });
};

const reducer = (state: StorymapState, action: SetWorkspaceMembersCanComment): void => {
    state.canWorkspaceMembersComment = action.canComment;
};

//@ts-ignore
registerMiddleware(SetWorkspaceMembersCanComment.ACTION_TYPE, middleware);

//@ts-ignore
registerReducer(SetWorkspaceMembersCanComment.ACTION_TYPE, reducer);
